import * as React from 'react';
import classNames from 'clsx';
import * as styles from './TopControls.css';
import { Layout } from '../Layout';

export interface ITopControlsLayoutProps {
  compare?: React.ReactNode;
  favorite: React.ReactNode;
  reviews?: React.ReactNode;
}

export function TopControls({ compare, favorite, reviews }: ITopControlsLayoutProps) {
  return (
    <div className={styles['container']}>
      <Layout>
        <div className={styles['inner_container']}>
          <div className={classNames(styles['item'], styles['item--reviews'])}>{reviews}</div>
          <div className={styles['item']}>
            {compare && <div>{compare}</div>}
            <div>{favorite}</div>
          </div>
        </div>
      </Layout>
    </div>
  );
}
